// extracted by mini-css-extract-plugin
export default {"container":"styles_container__DFjGm","paragraph":"styles_paragraph__EgnX5"};